import { render, staticRenderFns } from "./ContactoView.vue?vue&type=template&id=291a5460"
import script from "./ContactoView.vue?vue&type=script&lang=ts"
export * from "./ContactoView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports